import script from "./teamOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./teamOverview.vue?vue&type=script&setup=true&lang=js"

import "./teamOverview.vue?vue&type=style&index=0&id=7438fffa&lang=scss&scoped=true"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7438fffa"]])

export default __exports__